import React, {useEffect, useState} from "react";
import CvEditor from "./CvEditor";

import {XMLParser} from "fast-xml-parser"

import {send_bidib_cmd} from "../etc/cmd";
import c from "../etc/Const";
import DecoderDbIndex from "./DecoderDbIndex.tsx";


const Programmer = () => {

    const firmware = [
        'Firmware_145_31.57.decdb',
        'Firmware_151_5.3_DCC.decdb',
        'Firmware_97_3.13.decdb',
    ]

    const [dataJson, setDataJson] = useState(null)
    useEffect(() => {
        fetchXML(firmware[0])
    }, []);

    function readXML(xmltxt) {
        //setDataXML(xmltxt)

        const alwaysArray = [
            "decoderFirmwareDefinition.firmware.protocols.protocol",
            "decoderFirmwareDefinition.firmware.protocols.protocol.cvStructure.category",

            "decoderFirmwareDefinition.firmware.protocols.protocol.cvStructure.category.presetGroupIdReference",
            "decoderFirmwareDefinition.firmware.protocols.protocol.cvStructure.category.idReference",
            "decoderFirmwareDefinition.firmware.protocols.protocol.cvStructure.category.category",

            "decoderFirmwareDefinition.firmware.protocols.protocol.cvStructure.category.category.presetGroupIdReference",
            "decoderFirmwareDefinition.firmware.protocols.protocol.cvStructure.category.category.idReference",
            "decoderFirmwareDefinition.firmware.protocols.protocol.cvStructure.category.category.category",
        ];

        const options = {
            ignoreAttributes : false,
            attributeNamePrefix : "",
            allowBooleanAttributes: true,
            isArray: (name, jpath, isLeafNode, isAttribute) => {
                if( alwaysArray.indexOf(jpath) !== -1) return true;
            }
        };

        const parser = new XMLParser(options)
        const xml = parser.parse(xmltxt)

        setDataJson(xml)
    }

    function loadData() {
        let cc = {
            id: c.uuidv4(),
            cmd: 'load_decoder',
        }
        send_bidib_cmd(cc);
    }

    function fetchXML(name) {

        console.log("FETCH: ", name)

        //const name = "Firmware_145_31.57.decdb"
        //const name = "Firmware_151_5.3_DCC.decdb"

        fetch(name)
            .then(response => response.text())
            //.then(text => console.log(text))
            .then(text => readXML(text))

    }

    const style = {
        color: "green",
        backgroundColor: "lightgrey",
        margin: "10px",
        padding: "10px",
        overflow: 'auto',
    }

    const style2 = {
        color: "magenta",
        cursor: "pointer",
    }


    function onChange(val) {
        setDataJson(null)
        fetchXML(val)
    }


    return (
        <div style={style}>

            <select onChange={(e) => onChange(e.target.value)}>
                {firmware.map(it=> (
                    <option key={it} value={it}>{it}</option>
                ))}
            </select>

            <DecoderDbIndex/>

            <CvEditor data={dataJson}/>

        </div>
    )
}

export default Programmer
